// Core Modules
import { NgClass } from '@angular/common';
import { Component, inject, TemplateRef } from '@angular/core';

// External Modules
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';

// Services
import { ToastsService } from '@shared/services/toasts/toasts.service';

@Component({
  selector: 'app-toasts',
  templateUrl: './toasts-container.component.html',
  standalone: true,
  imports: [NgbToastModule, NgClass],
})
export class ToastsContainerComponent {
  // Injectors
  public readonly toastService = inject(ToastsService);

  public isTemplate(toast: { textOrTpl: string | TemplateRef<unknown> }): boolean {
    return toast.textOrTpl instanceof TemplateRef;
  }
}
